import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <div className="min-h-screen flex items-center justify-center bg-[#2A2A2A]">
        <div className="text-center px-4">
          <h1 className="text-5xl md:text-7xl font-poppins mb-6 text-[#F5F5F5]">{t('notFound.title')}</h1>
          <h2 className="text-2xl md:text-3xl font-poppins mb-4 text-[#C8102E]">{t('notFound.subtitle')}</h2>
          <p className="mb-8 max-w-md mx-auto text-[#CCCCCC]">
            {t('notFound.body')}
          </p>
          <Link
            to="/"
            className="px-6 py-3 bg-[#5F5F5F] text-white hover:bg-[#C8102E] transition-colors"
          >
            {t('common.returnHome')}
          </Link>
        </div>
      </div>
    </MainLayout>
  );
};

export default NotFound;
